export const getFetchTherapistCasesUrl = ({
  therapistId,
}: {
  therapistId: number | string;
}): string => `therapists/${therapistId}/cases`;
